import { JwtService } from './auth/jwt.service';
//import { Injectable } from '@angular/core';
//import { HttpClient, HttpParams } from '@angular/common/http';
//import { throwError, Observable } from 'rxjs';
//import { catchError } from 'rxjs/operators';
//import { Router } from '@angular/router';
//import { environment } from '../../../environments/environment';
//import { MessageService } from './message.service';
//import { HttpHeaders } from '@angular/common/http';
//import { MessageInfra } from 'src/app/structure/message/message-infra';
//import { EnumTipoMensagem } from '../enum/enum-infra';
//
//import { ConfigsLoaderService } from 'src/app/services/configs-loader.service';
//
//const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'},)};
//
//@Injectable({
//  providedIn: 'root'
//})
//
//export class ApiService {
//
//  msg: any;
//
//  constructor(
//    private http: HttpClient,
//    private router: Router,
//    private messageService: MessageService,
//    private configsLoaderService: ConfigsLoaderService
//  ) {}
//
//
//  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
//    return this.http.get(`${environment.ApiUrl}${path}`, { params })
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//  put(path: string, body: object = {}): Observable<any> {
//    return this.http.put(`${environment.ApiUrl}${path}`,
//      JSON.stringify(body),httpOptions)
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//
//  post(path: string, body: object = {}): Observable<any> {
//
//    return this.http.post(`${environment.ApiUrl}${path}`,
//      JSON.stringify(body), httpOptions)
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//  postWithToken(path: string, body: object = {}, token: string): Observable<any> {
//    return this.http.post(`${environment.ApiUrl}${path}`,
//      JSON.stringify(body),
//      {
//        headers:
//        {
//          Authorization: `Bearer ${token}`,
//          'Content-Type': 'application/json'
//        }
//      })
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//  putAttachment(path: string, formData: FormData): Observable<any> {
//    return this.http.put(`${environment.ApiUrl}${path}`,
//      formData,
//    )
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//  postAttachment(path: string, formData: FormData): Observable<any> {
//    return this.http.post(`${environment.ApiUrl}${path}`,
//      formData,
//    )
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//  delete(path: string): Observable<any> {
//    return this.http.delete(`${environment.ApiUrl}${path}`, httpOptions)
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//  postFile(path: string, fileToUpload: File): Observable<any> {
//    const formData: FormData = new FormData();
//    formData.set('formFile', fileToUpload);
//
//    return this.http
//      .post(`${environment.ApiUrl}${path}`, formData)
//      .pipe(catchError(err => this.notifyError(err)));
//  }
//
//
//  private notifyError(error: any) {
//    this.showError(error);
//    return throwError(error.error);
//  }
//
//  private showError(error: any) {
//
//    let errorMsg = '';
//
//    switch (error.status) {
//      case 400:
//        errorMsg = error.error.notifications ? `400 - ${error.error.notifications}` : `400 - ${error.error}`;
//        break;
//      case 401:
//        errorMsg = MessageInfra.AcessoNaoAutenticado;
//        this.router.navigateByUrl('/authentication/login');
//        break;
//      case 403:
//        errorMsg = MessageInfra.SemPermissaoDeAcesso;
//        break;
//      case 404:
//        errorMsg = MessageInfra.ServicoNaoEncontrado;
//        break;
//      case 405:
//        errorMsg = MessageInfra.ParametroEmFormatoInesperado;
//        break;
//      case 409:
//        errorMsg = `${MessageInfra.Conflito} - ${error.error}`;
//        break;
//      case 500:
//        errorMsg = `${MessageInfra.ErroInternoNoServidor}`;
//        break;
//      case 504:
//        errorMsg = MessageInfra.LimiteDeTempoExcedido;
//        break;
//      case 0:
//        errorMsg = MessageInfra.FalhaAoConectarComOServidor;
//        break;
//      default:
//        if (this.mappedRoutesErrors(error.url)) {
//          break;
//        }
//
//        if (error.error && error.error.errors && error.error.errors.length > 0) {
//          error.error.errors.forEach((element: string) => {
//            errorMsg += element + '; ';
//          });
//        }
//        break;
//    }
//
//    if (errorMsg) {
//      this.messageService.showNotify(errorMsg, EnumTipoMensagem.Erro);
//      this.msg = error.status;
//    }
//  }
//
//  private mappedRoutesErrors(url: string): boolean {
//
//    const mappedRoutes = ['Service/Negotiate', 'Service/Accept', 'Service/Refuse'];
//    let isNotificationError = 0;
//
//    for (let i = 0; i < mappedRoutes.length; i++) {
//
//      isNotificationError = url.indexOf(mappedRoutes[i]);
//      if (isNotificationError > 0) {
//        return true;
//      }
//    }
//
//    return false;
//  }
//
//  status() {
//    return this.msg;
//  }
//}



import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessageService } from './message.service';
import { HttpHeaders } from '@angular/common/http';
import { MessageInfra } from 'src/app/structure/message/message-infra';
import { EnumTipoMensagem } from '../enum/enum-infra';
import { GridObject } from '../model/grid-view';
import { ConfigsLoaderService } from 'src/app/services/configs-loader.service';



@Injectable({
  providedIn: 'root'
})

export class ApiService {
  httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization':'Bearer ' + this.jwtService.getToken() },) };
  msg: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private configsLoaderService: ConfigsLoaderService,
    private jwtService : JwtService
  ) { }

  getListPaged(obj: GridObject, rota: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('page', obj.Pagination.Page.toString());
    params = params.append('size', obj.Pagination.Size.toString());
    if (obj.Parameters)
      params = params.append('filter', obj.Parameters.filtro.toString());
    return this.http.get(`${this.configsLoaderService.ApiUrl}${rota}`, { params })
      .pipe(catchError(err => this.notifyError(err)));
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${this.configsLoaderService.ApiUrl}${path}`, { params })
      .pipe(catchError(err => this.notifyError(err)));
  }

  getImage(path: string): string {
    return `${this.http.get(`${this.configsLoaderService.ApiUrl}${path}`)}`;
  }

  async getIP(): Promise<any> {
    return await this.http.get(`http://api.ipify.org/?format=json`).toPromise()
  }

  put(path: string, body: object = {}): Observable<any> {

    return this.http.put(`${this.configsLoaderService.ApiUrl}${path}`,
      JSON.stringify(body), this.httpOptions)
      .pipe(catchError(err => this.notifyError(err)));
  }

  post(path: string, body: object = {}): Observable<any> {
    return this.http.post(`${this.configsLoaderService.ApiUrl}${path}`,
      JSON.stringify(body), this.httpOptions)
      .pipe(catchError(err => this.notifyError(err)));
  }

  postWithToken(path: string, body: object = {}, token: string): Observable<any> {
    return this.http.post(`${this.configsLoaderService.ApiUrl}${path}`,
      JSON.stringify(body),
      {
        headers:
        {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          anonymous: "true"
        }
      })
      .pipe(catchError(err => this.notifyError(err)));
  }

  putAttachment(path: string, formData: FormData): Observable<any> {
    return this.http.put(`${this.configsLoaderService.ApiUrl}${path}`,
      formData,
    )
      .pipe(catchError(err => this.notifyError(err)));
  }

  postAttachment(path: string, formData: FormData): Observable<any> {
    return this.http.post(`${this.configsLoaderService.ApiUrl}${path}`,
      formData,
    )
      .pipe(catchError(err => this.notifyError(err)));
  }

  delete(path: string): Observable<any> {

    return this.http.delete(`${this.configsLoaderService.ApiUrl}${path}`, this.httpOptions)
      .pipe(catchError(err => this.notifyError(err)));
  }

  postFile(path: string, fileToUpload: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.set('formFile', fileToUpload);

    return this.http
      .post(`${this.configsLoaderService.ApiUrl}${path}`, formData)
      .pipe(catchError(err => this.notifyError(err)));
  }

  download(url: string): Observable<any> {
    return this.http
      .get(`${this.configsLoaderService.ApiUrl}${url}`, { observe: 'body', responseType: 'blob' })
      .pipe(catchError(err => this.notifyError(err)));
  }

  downloadWithParams(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${this.configsLoaderService.ApiUrl}${path}`, { params, observe: 'body', responseType: 'blob' })
      .pipe(catchError(err => this.notifyError(err)));
  }

  private notifyError(response: HttpErrorResponse) {
    this.showError(response);
    if (response.status == 403) {
      response.error.errors = MessageInfra.SemPermissaoDeAcessoSemStatus;
    };
    return throwError(response.error.errors ? response.error.errors : response.error);
  }

  private showError(response: HttpErrorResponse) {
    let errorMsg = '';

    switch (response.status) {
      case 400:
        errorMsg = response.error.errors ? `400 - ${response.error.errors.join(' / ')}` : `400 - Ocorreu um erro no servidor.`;
        break;
      case 401:
        errorMsg = MessageInfra.AcessoNaoAutenticado;
        this.router.navigateByUrl('/authentication/login');
        break;
      case 403:
        errorMsg = MessageInfra.SemPermissaoDeAcesso;
        break;
      case 404:
        errorMsg = MessageInfra.ServicoNaoEncontrado;
        break;
      case 405:
        errorMsg = MessageInfra.ParametroEmFormatoInesperado;
        break;
      case 409:
        errorMsg = `${MessageInfra.Conflito} - ${response.error.errors.join(' / ')}`;
        break;
      case 500:
        if (response.error && response.error.errors && response.error.errors.length > 0)
          errorMsg = response.error.errors;
        else
          errorMsg = `${response.error.error}`;
        break;
      case 504:
        errorMsg = MessageInfra.LimiteDeTempoExcedido;
        break;
      case 0:
        errorMsg = MessageInfra.FalhaAoConectarComOServidor;
        break;
      default:
        //if (this.mappedRoutesErrors(response.url)) {
        {
           errorMsg = `${response.error.error}`;
        break;
        }

        if (response.error && response.error.errors && response.error.errors.length > 0) {
          response.error.errors.forEach((element: string) => {
            errorMsg += element + '; ';
          });
        }
        break;
    }

    if (errorMsg) {
      this.messageService.showNotify(errorMsg, EnumTipoMensagem.Erro);
      this.msg = response.status;
    }
  }

  private mappedRoutesErrors(url: string): boolean {

    const mappedRoutes = ['Service/Negotiate', 'Service/Accept', 'Service/Refuse'];
    let isNotificationError = 0;

    for (let i = 0; i < mappedRoutes.length; i++) {

      isNotificationError = url.indexOf(mappedRoutes[i]);
      if (isNotificationError > 0) {
        return true;
      }
    }

    return false;
  }

  status() {
    return this.msg;
  }

  async asyncPut(path: string, body: object = {}): Promise<any> {
    return await this.http.put(`${this.configsLoaderService.ApiUrl}${path}`,
      JSON.stringify(body), this.httpOptions).toPromise()
  }
  async asyncGet(path: string, params: HttpParams = new HttpParams()): Promise<any> {
    return await this.http.get(`${this.configsLoaderService.ApiUrl}${path}`, { params }).toPromise()
  }

  async asyncPost(path: string, body: object = {}): Promise<any> {
    return await this.http.post(`${this.configsLoaderService.ApiUrl}${path}`,
      JSON.stringify(body), this.httpOptions).toPromise()
  }


}



